import { TournamentType } from '@okletsplay/core';
import { useMemo } from 'react';

const POW_OF_TWO = 2;

export const useRoundCounts = (maxTeamsSize: number, eliminationFormat: TournamentType) => {
  return useMemo(() => {
    const count = Math.log(maxTeamsSize) / Math.log(POW_OF_TWO);
    const rounds = !Number.isInteger(count) ? 0 : count;

    if (eliminationFormat === TournamentType.DoubleEliminationTournament) {
      return rounds + 1;
    }

    return rounds;
  }, [eliminationFormat, maxTeamsSize]);
};
